import { render } from "./ActorListView.vue?vue&type=template&id=995f6222"
import script from "./ActorListView.vue?vue&type=script&lang=js"
export * from "./ActorListView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__